import React from 'react'
import { useDrag } from 'react-dnd'

interface DraggableChildProps {
  id: string;
  type: string;
  label?: string;
  dropLabel?: string;
  isInfo: boolean;
  isMandatory: boolean;
  preserveLabelOnDrop?: boolean;
  isDataRow?: boolean;
  className?: string;
}

const DraggableChild: React.FC<DraggableChildProps> = ({ id, type, label, dropLabel, isInfo, preserveLabelOnDrop = true, isDataRow, className }) => {
  const [, dragRef] = useDrag(() => ({
    type: 'CHILD',
    item: preserveLabelOnDrop ? { id, type, label: dropLabel ?? label, isInfo, isDataRow, className } : { id, type, isInfo, isDataRow, className },
  }))

  return (
    <div
      ref={dragRef}
      className='border-2 whitebg border-radius p-2 mb-1'
    >
      {label}
    </div>
  )
}

export default DraggableChild
